import { InjectionToken, Signal } from '@angular/core';

export interface DocumentSearchEntry {
  id: string;
  searchTexts: readonly string[];
}

export interface EinvoiceDocumentSearchState {
  readonly searchResultIds: Signal<ReadonlySet<string>>;
  readonly currentSearchResultId: Signal<string | undefined>;
}

export const EINVOICE_DOCUMENT_SEARCH_STATE = new InjectionToken<EinvoiceDocumentSearchState>('EINVOICE_DOCUMENT_SEARCH_STATE');